<template>
    <div class="g-h100">
        <div class="g-h100 g-flex-vh-center" v-if="showEmpty">
            <van-empty 
                description="暂时还没有活动哦～" 
                image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png" 
                image-size="128" />
        </div>
        <van-list 
            v-else 
            v-model="state.loading" 
            :finished="state.finished" 
            finished-text="没有更多了" 
            @load="onLoad">
            <van-cell v-for="i in state.list" :key="i.id">
                <div class="ph6 list" @click="toDetail(i.id)">
                    <div class="g-flex">
                        <van-image 
                            width="40" 
                            height="40" 
                            :src="`https://cdn01.xiaogj.com/uploads/x3/assets/m/img/parent/member/act${i.type}.png`" />
                        <div class="ml">
                            <p class="name">{{ i.name }}</p>
                            <div v-if="i.timeType === 1" class="date">
                                <p>
                                    <span>开始时间:</span>
                                    <span>{{ i.startDate }}</span>
                                </p>
                                <p>
                                    <span>结束时间:</span>
                                    <span>{{ i.endDate }}</span>
                                </p>
                            </div>
                            <div v-if="i.timeType === 0" class="date">
                                <p>
                                    <span>开始时间:</span>
                                    <span>每月{{ i.startDay }}日</span>
                                </p>
                                <p>
                                    <span>结束时间:</span>
                                    <span>每月{{ i.endDay }}日</span>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div :style="{ color: colors[i.status] }">{{ statusNames[i.status] }}</div>
                </div>
            </van-cell>
        </van-list>
    </div>
</template>

<script>
export default {
    name: 'activityList',
    props: {
        active: {
            type: Number,
            default: 0
        },
        name: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            statusNames: ['未开始', '进行中', '已结束'],
            colors: ['#FFB900', '#FE6760', '#969799'],
            showEmpty: false,
            state: {
                list: [],
                loading: false,
                finished: false,
                page: 1
            },
        }   
    },
    computed: {      
        memberUseInfo () {
            return this.$store.state.memberUserInfos || {};
        },
    },
    methods: {
        onLoad () {
            let {active,name,state} = this;
            this.$api.pageMemberActivity({
                memberId: this.memberUseInfo.id,
                status: active === 0 ? '' : active - 1,
                name,
                page: state.page,
                pageSize: 15
            }).then(res => {
                state.page++
                state.loading = false
                const list = (res.data && res.data.records) || []
                state.list.push(...list)

                if (res.data.total <= state.list.length) {
                    state.finished = true
                }
                if (state.list.length === 0) {
                    this.showEmpty = true
                }
            })
        },
        toDetail (id){
            const { companyId, companyName } = this.memberUseInfo
            this.$router.push(`/member-activity-detail?id=${id}&companyId=${companyId}&companyName=${companyName}`)
        }
    }
}
</script>

<style lang="scss" scoped>
.g-h100 {
    height: 100%;
}
.g-flex {
    display: flex;
}
p{
    margin: 0;
}
.g-flex-vh-center {
    display: flex;
    justify-content: center;
    align-items: center;
}
.ph6 {
    padding: 6px 0;
}
.date {
    font-size: 12px;
    color: #969799;
    margin-top: 2px;
}
.list {
    display: flex;
    justify-content: space-between;
}
.ml {
    margin-left: 16px;
}
.name {
    max-width: 160px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-size: 16px;
    font-weight: 400;
}
</style>
